module.exports = __webpack_public_path__ + "static/media/speedometer.75c41eb0.svg";